import {createI18n} from 'vue-i18n/index';
import locale from '@/assets/js/locale';

const messages = require('@/assets/i18n/translations.json');

const i18n = createI18n({
  locale: locale.getLocale(),
  fallbackLocale: locale.fallback,
  messages,
});

export default i18n;
